export const TEXT_SHOULD_FORWARD_PROP = [
  'body',
  'body12',
  'body14',
  'body16',
  'body20',
  'bold',
  'capitalize',
  'caption12',
  'center',
  'ellipsis',
  'invertedBody',
  'invertedMuted',
  'invertedSlight',
  'invertedTitle',
  'justify',
  'left',
  'letterSpace',
  'light',
  'lineHeight',
  'link',
  'linkColor',
  'markdown',
  'maxWidth',
  'medium',
  'minHeight',
  'monospace',
  'muted',
  'nowrap',
  'preWrap',
  'right',
  'secondary',
  'semiLight',
  'small',
  'textAlign',
  'title',
  'title28',
  'title40',
  'title52',
  'underline',
  'uppercase',
  'white',
]

export const DIV_SHOULD_FORWARD_PROP = [
  'alignCenter',
  'alignEnd',
  'alignItems',
  'alignStart',
  'backgroundColor',
  'borderBottom',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderColor',
  'borderRadius',
  'borderTop',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'center',
  'children?:',
  'classNam',
  'flexDirection',
  'flexGrow',
  'flexWrap',
  'fullHeight',
  'fullScreen',
  'fullWidth',
  'gridColumnGap',
  'gridGap',
  'gridRowGap',
  'gridTemplateAreas',
  'gridTemplateColumns',
  'grow',
  'justifyCenter',
  'justifyContent',
  'justifyEnd',
  'maxHeight',
  'maxWidth',
  'minHeight',
  'minWidth',
  'noShrink',
  'overflowX',
  'overflowY',
  'pointer',
  'relative',
  'spaceBetween',
  'squeeze',
  'wrap',
  'zIndex',
]
